import React from 'react'
import t from '~t'
import config from '~config'
import { Button, Icon } from '~ui';

export default ({ className, spaceId })=>(
    <Button variant='ghost' 
        className={className}
        href={new URL(`/my/${spaceId}`, config.links.app.index).toString()}
        target='_blank'
        title={t.s('openInNewTab')}>
        <Icon name='open' size='micro' />
    </Button>
)